import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function FinalPricingCTA() {
  return <section className="py-12 md:py-16 bg-[#064e3b] text-white text-center relative overflow-hidden" data-id="element-51">
      <div aria-hidden="true" className="absolute top-0 left-0 w-full h-full overflow-hidden z-0 pointer-events-none" data-id="element-52">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[100%] h-[100%] rounded-full bg-emerald-500/30 blur-[100px]" data-id="element-53" />
      </div>

      <div className="container mx-auto px-4 max-w-3xl relative z-10" data-id="element-54">
        <h2 className="text-3xl md:text-5xl font-bold font-heading text-white mb-6 leading-tight" data-id="element-55">
          No dejes que la improvisación siga limitando el nivel de tu
          consultorio.
        </h2>
        <p className="text-lg text-emerald-100 mb-10 max-w-2xl mx-auto" data-id="element-56">
          Empezá hoy mismo con el sistema que ya está transformando la práctica
          de profesionales en toda Argentina y Latinoamérica.
        </p>

        <div className="bg-white rounded-3xl p-8 shadow-2xl max-w-xl mx-auto mb-8 border-4 border-yellow-400" data-id="element-57">
          <h3 className="font-bold text-slate-900 mb-2 text-sm uppercase tracking-wide" data-id="element-58">
            Masterpack de Protocolos Clínicos de Nutrición + Todos los Bonos
          </h3>
          <div className="text-slate-400 line-through mb-1 text-lg" data-id="element-59">
            $83.900 ARS
          </div>
          <div className="text-5xl font-black text-slate-900 mb-6" data-id="element-60">$19.990</div>

          <motion.a href="https://masterpack-de-protocolos-clinicos-de-nutricion.impultienda.ar/checkout" whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="flex items-center justify-center gap-3 w-full bg-yellow-400 hover:bg-yellow-300 text-slate-900 font-black text-lg md:text-xl px-6 py-5 rounded-full shadow-lg transition-colors mb-4" data-id="element-61">
            <span data-id="element-62">🚀 SÍ, QUIERO EL MASTERPACK HOY</span>
            <ArrowRight className="w-6 h-6" data-id="element-63" />
          </motion.a>
        </div>

        <div className="flex flex-col sm:flex-row justify-center items-center gap-4 text-sm text-emerald-200 font-medium" data-id="element-64">
          <span data-id="element-65">⭐⭐⭐⭐⭐ 4.9/5 Avalado por Profesionales</span>
          <span className="hidden sm:inline" data-id="element-66">|</span>
          <span data-id="element-67">🛡️ Garantía de 7 Días</span>
        </div>
      </div>
    </section>;
}